<div class="error-global-page">
    <div class="error-title">{{ errorTitle }}</div>
    <div class="error-subtitle">{{ errorSubtitle }}</div>
</div>
